// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2tSjA","topBottomGutter":"Layout_topBottomGutter__3_xKS"};